import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckRanAssignedTemplates } from '@api/consistencyCheck';

import { mapDropdownOptions } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_RAN_ASSIGNED_TEMPLATE } from '@constants/queryKeys';

interface IUseQueryConsistencyCheckRanConsistencyAssignedTemplates {
	assignedTemplateOptions: TSelectOption<string>[];
	isLoadingAssignedTemplateOptions: boolean;
}

const useQueryConsistencyCheckRanConsistencyAssignedTemplates = (
): IUseQueryConsistencyCheckRanConsistencyAssignedTemplates => {
	const {
		data,
		isFetching,
		isLoading,
	} = useQuery({
		queryKey: [CONSISTENCY_RAN_ASSIGNED_TEMPLATE],
		queryFn: getConsistencyCheckRanAssignedTemplates,
		select: (data) => mapDropdownOptions({
			items: data,
			valueKey: 'id',
			labelKey: 'name',
		}),
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		assignedTemplateOptions: data || [],
		isLoadingAssignedTemplateOptions: (!!data && isLoading) || isFetching,
	};
};

export default useQueryConsistencyCheckRanConsistencyAssignedTemplates;
